export default __webpack_public_path__ + "static/media/Jumia-Logo.b9ed252f.jpg";